import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var ResponseComposer = require("components/writing/responses/ResponseComposer");
var Spinner = require("components/utility/Spinner");
var CurrentUser = require("lib/account/CurrentUser");
var Board = require("components/utility/Board");
var BookTextVariety = require("components/reading/books/BookTextVariety");
var TextTypes = require("lib/academic/TextTypes");
var Features = require("lib/account/Features");
var StudentMetrics = require("lib/data/StudentMetrics");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var CurrentUser = require("lib/account/CurrentUser");

@connect(
	(state, props) => ({
	}),

	(dispatch, props) => ({
	})
)
// @providePopulateData({ waitForLoad: true })

class NewResponsePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			activityOptions: null, assignedActivites: null, book: null,
			activityID: null, draftResponseID: null
		}
	}

	isAdminPreview() {
		return CurrentUser.isTeacherAdmin();
	}

	getTextID() {
		if (this.state.book) {
			return this.state.book.text_id;
		} else {
			return $wr.getURLParameterByName("text_id");
		}
	}

	selectActivity(activity) {
		this.setState({ activityID: activity.id });
	}

	selectAssignedActivity(activityID) {
		this.setState({ activityID: activityID });
	}

	loadActivityOptions() {
		var params = {
			embed: "activity.format_summary",
		};
		var activityOptions = []
		CurrentUser.api().getActivities(params, $wr.apiHandler(function (response) {
			activityOptions = response.activities;
			this.getStudents(activityOptions);
		}.bind(this)));
	}

	getAssignedExercises(exerciseIDs) {
		var exercises = []
		_.each(exerciseIDs, (exerciseID, index) => {
			CurrentUser.api().getActivity(exerciseID, { embed: "activity.format" }, $wr.apiHandler(function (serverResponse) {
				exercises = [...exercises, serverResponse.activity]
				if (index === (exerciseIDs.length - 1)) {
					this.setState({activityOptions: exercises})
				}
			}.bind(this)));
		})
	}

	getStudents(activityOptions) {
		var assignmentsParams = {
			embed: "current_tasks,task.subject,activity.format_summary"
		}

		CurrentUser.api().getStudent(CurrentUser.get().id, assignmentsParams, $wr.apiHandler((response) => {
			this.setState({ assignedActivites: response.student.current_tasks });
			if (this.state.assignedActivites !== null && activityOptions.length) {
				this.filterActivityOptions(activityOptions)
			}
		}));
	}
	// filter activities based on url parameter
	filterActivityOptions(activityOptions) {
		// build activity options based on url param
		var queryString = window.location.search;
		var urlParams = new URLSearchParams(queryString);
		var activityIDs = urlParams.get('activity_ids')

		// var standAloneExerciseIDs = _.pluck(_.where(this.state.assignedActivites, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }), 'subject_id')
		// var exerciseTaskItemIDs = _.pluck(_.where(_.flatten(_.pluck(this.state.assignedActivites, 'task_items')), { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }), 'subject_id')
		// var usedExerciseIDs = _.map(_.collect(_.uniq(standAloneExerciseIDs.concat(exerciseTaskItemIDs))), exerciseID => { return parseInt(exerciseID)})

		// filter out activities that aren't assigned or are completed
		if (activityIDs !== 'none' && activityIDs !== null && this.state.assignedActivites !== null) {
			activityIDs = activityIDs.includes(',') ? activityIDs.split(',') : [activityIDs]
			activityIDs = _.map(activityIDs, (id) => { return parseInt(id) })
			// retrives exercises that are assigned
			if (activityIDs.length) {
				var exercises = []
				_.each(activityIDs, (exerciseID, index) => {
					CurrentUser.api().getActivity(exerciseID, { embed: ["activity.format", "activity.format_summary"] }, $wr.apiHandler(function (serverResponse) {
						exercises = [...exercises, serverResponse.activity]
						if (index === (activityIDs.length - 1)) {
							this.setState({ activityOptions: exercises })
						}
					}.bind(this)));
				})
			} else {
				this.setState({ activityOptions: activityOptions });
			}
		}
		else {
			this.setState({ activityOptions: activityOptions });
		}
	}
	// load book information to redux
	fetchBook(bookID) {
		var activityID = parseInt($wr.getURLParameterByName("activity_id"));
		if (bookID != 'null') {
			var params = { embed: "book.responses", draft: "only" };
			CurrentUser.api().getBook(bookID, params, $wr.apiHandler(function (response) {
				var book = _.omit(response.book, "responses");

				var draftResponse = response.book.responses[0];

				if (draftResponse && ((!activityID) || (draftResponse.activity_id == activityID))) {
					this.setState({ book: book, draftResponseID: draftResponse.id, activityID: draftResponse.activity_id });
				} else {
					this.setState({ book: book }, function () {
						if ($wr.getURLParameterByName("activity_id")) {
							this.setState({ activityID });
						} else {
							this.loadActivityOptions();
						}
					}.bind(this));
				}
			}.bind(this)));
		} else if (activityID) {
			var newState = { activityID }
			
			var params = { user_id: CurrentUser.get().id, activity_id: activityID, draft: "only", text_id: null }
			CurrentUser.api().getResponses(params, $wr.apiHandler(function (serverResponse) {

				if (_.size(serverResponse.responses)) {
					var draftResponse = serverResponse.responses[0];
					newState = {...newState, draftResponseID: draftResponse.id}
				}

				this.setState({ ...newState });
			}.bind(this)));
		} else {
			this.loadActivityOptions();
		}
	}

	renderChooseActivity() {
		var student = CurrentUser.get();
		if (CurrentUser.hasID(student)) {
			var tasks = this.state.assignedActivites;
			var collaboration = student.current_collaboration;
		}
		var className = " largerHeader";

		return (
			<div>
				<h3 className="textTitle onQuestionSelect">
					{ this.state.book.title }
				</h3>
				<header className="pageHeader">
					<h1 className={ "selectExerciseTitle" + className }>Choose an Exercise</h1>
				</header>	
				<Board type={ Board.STUDENT_ACTIVITIES } items={ this.state.activityOptions }
					onTileClick={ this.selectActivity } />
			</div>
		);
	}

	render() {
		if (this.state.book && !this.state.book.text_variety) {
			var pageContent = (
				<div className="textVariety">
					<header className="pageHeader">
						<h1>Select a Book Type</h1>
					</header>
					<h3 className="textTitle">
						{ this.state.book.title }
					</h3>
					<BookTextVariety book={ this.state.book } selectForActivity={true} 
						fetchBook={ this.fetchBook(this.getTextID()) } />	
				</div>
			)
		} else if (this.state.activityID) {
			var pageContent = (
				<ResponseComposer activityID={ this.state.activityID } 
					responseID={ this.state.draftResponseID } book={ this.state.book }
					adminPreview={ this.isAdminPreview() } />
			);
		} else if (this.state.activityOptions) {
			var pageContent = this.renderChooseActivity();
		} else {
			var pageContent = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		}

		return (
			<div className="container newResponsePage">
				{ pageContent }
			</div>
		);
	}

	componentDidMount() {
		if (this.getTextID()) {
			this.fetchBook(this.getTextID());			
		} else if ($wr.getURLParameterByName("activity_id")) {
			this.setState({ activityID: parseInt($wr.getURLParameterByName("activity_id")) });
		}
	}
};

NewResponsePage.propTypes = PageStrictPropTypes({

});

module.exports = NewResponsePage;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/NewResponsePage.js